import { render, staticRenderFns } from "./ImgVerify.vue?vue&type=template&id=700cb84b"
import script from "./ImgVerify.vue?vue&type=script&lang=js"
export * from "./ImgVerify.vue?vue&type=script&lang=js"
import style0 from "./ImgVerify.vue?vue&type=style&index=0&id=700cb84b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports